import styled from "styled-components";
import { DIGIPOSTHEME } from "theme/digiPosTheme";

export const WrapperRadio = styled.div`
  height: auto;
  width: 100%;
  display: flex;
  justify-content: flex-end;
  align-items: center;
`;
export const RadioButtonItem = styled.div`
  display: flex;
  align-items: center;
  position: relative;
`;
export const RadioButtonCircle = styled.label`
  position: absolute;
  top: 25%;
  left: 4px;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background: white;
  border: 1px solid #ccc;
  outline: none;
`;
export const Radio = styled.input`
  opacity: 0;
  z-index: 1;
  cursor: pointer;
  width: 20px;
  height: 20px;
  margin-right: 10px;
  &:hover ~ ${RadioButtonCircle} {
    background: #ccc;
    &::after {
      display: block;
      color: white;
      width: 12px;
      height: 12px;
      margin: 4px;
    }
  }
  &:checked + ${RadioButtonItem} {
    background: ${DIGIPOSTHEME.colors.darkBlack};
    border: 4px solid ${DIGIPOSTHEME.colors.white};
    box-shadow: 0 0 0 1px ${DIGIPOSTHEME.colors.darkBlack};
  }
  &:checked + ${RadioButtonCircle} {
    background: ${DIGIPOSTHEME.colors.darkBlack};
    border: 4px solid ${DIGIPOSTHEME.colors.white};
    box-shadow: 0 0 0 1px ${DIGIPOSTHEME.colors.darkBlack};
    &::after {
      display: block;
      color: white;
      width: 12px;
      height: 12px;
      margin: 4px;
      padding: 5px;
    }
  }
`;
